export default {
  container: {
    display: "grid",
    flexWrap: "nowrap",
    gap: "0.5rem",
    border: "none",
    gridTemplateColumns: "repeat(3, 1fr)",
    // gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
    padding: 0,
  },
};
